import {getHeaders} from '@core/actions/xhrRequest';
import {createAction} from 'redux-api-middleware';

export const FETCH_RESUME_OPTIONS_INIT = 'FETCH_RESUME_OPTIONS_INIT';
export const FETCH_RESUME_OPTIONS_SUCCESS = 'FETCH_RESUME_OPTIONS_SUCCESS';
export const FETCH_RESUME_OPTIONS_FAILURE = 'FETCH_RESUME_OPTIONS_FAILURE';

export const getResumeOptions = () => createAction({
    types: [
        FETCH_RESUME_OPTIONS_INIT,
        {
            type: FETCH_RESUME_OPTIONS_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(data => {
                    const payMethods = data.payMethods
                        ? Object.values(data.payMethods).sort((a, b) => (b.priority || 0) - (a.priority || 0))
                        : [];

                    return {...data, payMethods};
                });
            },
        },
        FETCH_RESUME_OPTIONS_FAILURE,
    ],
    endpoint: '/api/resume-dependency',
    headers: getHeaders(),
    method: 'POST',
    credentials: 'include',
});
